import { MetaData, SpecialistsPage } from '@/components'

export default function NextSpecialistsPage(props) {
  const { meta } = props.paginator;
  const { title: titleFromProps, description: descFromProps } = meta;
  const title = titleFromProps || "Врачи медицинского центра «Sante» в Минске";
  const description = descFromProps || "Полный перечень врачей медицинского центра «Sante» в Минске. В штате центра состоят только опытные специалисты - профессора, доценты, кандидаты медицинских наук."

  return (
    <>
      <MetaData title={title} description={description}/>
      <SpecialistsPage {...props} />
    </>
  )
}

NextSpecialistsPage.getInitialProps = async ({ query, api }) => {
  const { page, ...queries } = query
  const response = await api.specialists(page, queries)

  const { directions, ...paginator } = response
  return { directions, paginator }
}
